import { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { getApi } from './index';
import { Headers } from '../types';

export const createLiteSession = (appTarget: string) => {
  const getHeaders = () => ({ [Headers.APP_TARGET]: appTarget });

  return getApi(AuthStrategy.SESSION)
    .addHeaders(getHeaders)
    .onError(() => ({}))
    .post(`${process.env.REACT_APP_GATEKEEPER_URL}/lite-sessions`);
};

export async function getLiteSession(appTarget: string): Promise<Record<string, any>> {
  const response = await createLiteSession(appTarget);

  return response.data || {};
}
